import * as actions from "./licenseActionType"

export const licenseRequest = (): actions.LicenseRequest => {
    return {
        type: actions.LICENSE_REQUEST,
    };
};

export const licenseRequestSuccess = (payload?: any): actions.LicenseRequestSuccess => {
    return {
        type: actions.LICENSE_REQUEST_SUCCESS,
        payload,
    };
};

export const licenseRequestFailed = (payload: any): actions.LicenseRequestFailed => {
    return {
        type: actions.LICENSE_REQUEST_FAILED,
        payload,
    };
};

export const licenseProcessReset = (): actions.LicenseProcessReset => {
    return {
        type: actions.LICENSE_PROCESS_RESET,
    };
};